import { render, staticRenderFns } from "./EchartBar.vue?vue&type=template&id=67f08336&scoped=true&"
import script from "./EchartBar.vue?vue&type=script&lang=js&"
export * from "./EchartBar.vue?vue&type=script&lang=js&"
import style0 from "./EchartBar.vue?vue&type=style&index=0&id=67f08336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f08336",
  null
  
)

export default component.exports